import { IconProps } from './types';
import { useId } from 'react';

export default function IconPause({ width = '24', height = '24', stroke = '#8A0B00', stopColor = '#FFD080', className }: IconProps) {
    const baseId = useId().replace(/:/g, '')
    const leftGradientId = `${baseId}-pause-gradient-left`
    const rightGradientId = `${baseId}-pause-gradient-right`

    return (
        <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
            <path d='M10.4836 20.8611L5.44737 21.0297L5.19319 3.32186L8.90162 3.16062L10.4836 20.8611Z' fill={`url(#${leftGradientId})`} stroke={stroke} />
            <path d='M19.5758 3.20696L18.8145 20.9513L14.646 20.9601L14.5232 3.24242L19.5758 3.20696Z' fill={`url(#${rightGradientId})`} stroke={stroke} />
            <defs>
                <linearGradient id={leftGradientId} x1='6.78687' y1='2.72648' x2='7.41402' y2='21.4635' gradientUnits='userSpaceOnUse'>
                    <stop stopColor={stopColor} />
                    <stop offset='1' stopColor='white' />
                </linearGradient>
                <linearGradient id={rightGradientId} x1='17.0586' y1='2.72477' x2='17.1901' y2='21.4656' gradientUnits='userSpaceOnUse'>
                    <stop stopColor={stopColor} />
                    <stop offset='1' stopColor='white' />
                </linearGradient>
            </defs>
        </svg>
    )
}
